import { NavLink as RouterNavLink, useLocation } from 'react-router';
import { cn } from '@/lib/utils';

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
}

export function NavLink({ to, children }: NavLinkProps) {
  const { pathname } = useLocation();

  const handleClick = (e: React.MouseEvent) => {
    // Match scio1: clicking the current page's tab is a no-op — stay in current folder/view
    if (pathname === to || pathname.startsWith(to + '/')) {
      e.preventDefault();
    }
  };

  return (
    <RouterNavLink
      to={to}
      onClick={handleClick}
      className={({ isActive }) =>
        cn(
          'relative inline-flex items-center px-3 py-1 rounded-md text-sm font-medium transition-colors after:absolute after:bottom-0 after:left-2 after:right-2 after:h-0.5 after:rounded-full after:transition-colors',
          isActive
            ? 'text-foreground after:bg-primary'
            : 'text-muted-foreground after:bg-transparent hover:bg-sidebar-active hover:text-foreground focus-visible:bg-sidebar-active focus-visible:text-foreground focus-visible:after:bg-primary',
        )
      }
    >
      {children}
    </RouterNavLink>
  );
}
